import { FaSpinner } from 'react-icons/fa6'
import useRequestsActions from '../../hooks/useRequestsActions'
import { toastError, toastSuccess } from '../../../helper'
import { useRef } from 'react'
import ButtonRequestsOptions from './ButtonRequestsOptions'

export default function RequestsGridItem({ request }) {
  return (
    <div className="col-span-12 flex flex-col border-2 border-muted-600 bg-white md:col-span-6 lg:col-span-4 xl:col-span-3">
      <div className="flex flex-col gap-2 p-2">
        <div className="flex items-center justify-between">
          <img
            className="h-7 w-10 border-2 border-muted-500"
            src={`${process.env.REACT_APP_API_BASE_URL}/storage/flags/${request?.country?.image}`}
            alt="country flag"
          />
          <div
            className={`text-priamry-600 border-2 px-2 py-1 text-xs ${
              request.status === 'OPEN'
                ? 'border-primary-500 bg-primary-300'
                : request.status === 'IN_PROGRESS'
                  ? 'border-accent-500 bg-accent-300'
                  : request.status === 'REJECTED'
                    ? 'border-danger-500 bg-danger-300'
                    : 'border-success-500 bg-success-300'
            }`}
          >
            {request?.status === 'OPEN'
              ? 'مفتوح'
              : request?.status === 'IN_PROGRESS'
                ? 'قيد التنفيذ'
                : request?.status === 'REJECTED'
                  ? 'مرفوض'
                  : request?.status === 'CLOSE'
                    ? 'مغلق'
                    : 'مكتمل'}
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <h2>
            <span className="font-bold">الاسم الكامل :</span>{' '}
            {request?.full_name}
          </h2>
          <h2>
            <span className="font-bold">الجهة المعنية :</span>{' '}
            {request?.concerned_party}
          </h2>
          <h2>
            <span className="font-bold">البريد الإلكتروني :</span>{' '}
            {request?.email}
          </h2>
          <h2>
            <span className="font-bold">رقم الهاتف :</span> {request?.phone}
          </h2>
          <h2>
            <span className="font-bold">باقة الرعاية :</span>{' '}
            {request?.sponsor_package?.name_ar}
          </h2>
        </div>
      </div>
      <div className="flex justify-between gap-2 border-t-2 border-muted-500 p-1">
        <div></div>
        <ButtonRequestsOptions request={request} />
      </div>
    </div>
  )
}
